export * from "./currency";
export * from "./fp";
export * from "./localization";
export * from "./location";
export * from "./number";
export * from "./payment";

export const prefixClassUtil = (preNameClass: string) => (name: string) => `${preNameClass}__${name}`;
